import React, { useEffect, useRef, useState } from "react";
// import { FToggle } from "../../../global/switch";
import { FButton, FDialog } from "ferrum-design-system";
import { useHistory } from "react-router";

export const MsSlippageToleranceDialog = ({
  show,
  onHide,
}: {
  show: boolean;
  onHide: () => void;
}) => {
  const history = useHistory();
  const slippageInput = useRef<HTMLInputElement>(null);
  const queryParams = new URLSearchParams(window.location.search);
  const [slippage, setSlippage] = useState<string>(
    queryParams.get("slippage") || "2"
  );

  useEffect(() => {
    slippageInput.current?.focus();
  }, [show]);

  return (
    <FDialog
      show={show}
      size={"medium"}
      onHide={() => {
        onHide();
        queryParams.set("slippage", slippage);
        history.push({
          pathname: "/swap",
          search: queryParams.toString(),
        });
      }}
      variant={"slippage-tolerance"}
      title="Slippage Tolerance"
    >
      <>
        <div className="slippage-body">
          <div className="ms-slippage-tolerance-buttons">
            <FButton
              title={"AUTO"}
              className="auto-button"
              onClick={() => setSlippage("2")}
            />
            <input
              placeholder="Enter Slippage Tolerance"
              type="text"
              ref={slippageInput}
              value={slippage}
              onChange={(e) => {
                console.log(e.target.value);
                setSlippage(e.target.value);
              }}
            />
          </div>
          <div className="ms-slippage-tolerance-auto-refresh">
            <span>
              Current slippage on source and destination networks is{" "}
              {slippage ? slippage : "2"}% each.
            </span>
          </div>
        </div>
      </>
    </FDialog>
  );
};
